import m, {Vnode} from "mithril";
import h from "../../ui/design";
import ICustomFormSettings from "../../customForms/ICustomFormSettings";

export default class Controls {

    public static readonly PREVIOUS_BUTTON_SELECTOR = "button.btn.large.outline.secondary#previousButton";
    public static readonly LANGUAGE_BUTTON_SELECTOR = "button.btn.large.outline.secondary#languageButton";
    public static readonly PRIMARY_BUTTON_SELECTOR = "button.btn.large.raised.primary#nextButton";

    public nextButtonText = 'nextButton';
    public onNext: (()=>void)|null = null;

    constructor(
        private readonly settings: ICustomFormSettings,
        private readonly autoValidate: boolean,
    ) { }

    public viewPreviousButton(text?: string, callback?: ()=>void): Vnode {
        const questionary = this.settings.form.questionary;
        return m(Controls.PREVIOUS_BUTTON_SELECTOR, {
            onclick: () => {
				if (callback) {
					callback();
				} else {
                    this.settings.prevForm();
				}
            },
            title: questionary.renderText(questionary.messages.get(text ?? 'backButton')),
            tabindex: 3,
        }, text ? text : [
             m('i.icon.icon-chevron-left', {}, ''),
        ]);
    }

    public viewLanguageButton(): Vnode {
        const questionary = this.settings.form.questionary;

        return m(Controls.LANGUAGE_BUTTON_SELECTOR, {
            onclick: () => this.settings.selectLanguage(),
            title: questionary.renderText(questionary.messages.get('language')),
            tabindex: 2,
        }, [
            m('i.icon.icon-translate', {}, '')
        ]);
    }

    public viewNextButton(text?: string, callback?: ()=>void, validate?: ()=>boolean): Vnode {
        const questionary = this.settings.form.questionary;
        const enableNextButton = validate ? validate() : (this.autoValidate ? this.settings.form.validate() : true);

        return m(Controls.PRIMARY_BUTTON_SELECTOR + (enableNextButton?h.backgroundPrimary:h.backgroundDisabled), {
            onclick: () => {
                if (callback) {
                    callback();
                } else if (this.onNext) {
                    this.onNext()
                } else {
                    this.settings.nextForm();
                }
            },
            tabindex: 1,
            disabled: enableNextButton ? false : 'disabled',
        }, [
            m('span', {}, questionary.renderText(questionary.messages.get(text ?? 'nextButton')) ),
            m('i.icon.icon-chevron-right'+(enableNextButton?'.text-light':''), {}, '')
        ]);
    }

    public view() {

        const visiblePreviousButton = this.settings.app.prevEnabled();
        const visibleLangButton = this.settings.app.langSwitcherEnabled();
        const visibleNextButton = this.settings.app.nextEnabled();

        if (!visiblePreviousButton && !visibleLangButton && !visibleNextButton) {
            return null;
        }

        return m(".controls", {},
            m(".control-group", {}, [
                visiblePreviousButton ? this.viewPreviousButton() : null,
                visibleLangButton ? this.viewLanguageButton() : null,
                visibleNextButton ? this.viewNextButton(this.nextButtonText) : null,
            ])
        );
    }
}
